import * as App from "@timesheets/routes-app";

import { IGroupRoute } from "./IGroupRoute";
import { PageTypes } from "./PageTypes";
import { Route } from "@gemma/utils";
import { Routing } from "@timesheets/webapp-support";
import { TRouteMetaGroup } from "./TRouteMetaGroup";
import { WireEntities } from "@timesheets/common";

export function redirectToRolesList(pageType: PageTypes, currentRoute: IGroupRoute, userRole?: WireEntities.Roles.IRole): Routing.RouteResult<TRouteMetaGroup> {
  if (currentRoute.path.startsWith(App.Roles.Root)) {
    if (pageType === PageTypes.AccountPages) {
      return { continue: false, route: currentRoute };
    } else {
      return { continue: true, route: undefined };
    }
  } else {
    let route = new Route<TRouteMetaGroup>(App.Roles.Root, currentRoute.searchTerms, currentRoute.meta);
    if (userRole) {
      route.setSearchTerm("roleId", userRole.id);
    }

    if (pageType === PageTypes.AccountPages) {
      return { continue: false, route };
    } else {
      return { continue: true, route };
    }
  }
}
